// LabReportService.js
//
// Service backing the PUBLIC lab report page (https://healthcarelife.in/lab-report/:id).
// Talks to:
//   GET /makereportfirsttype/booking/{patientTestBookingId}/report-status
// which returns a BaseResponseOne wrapping BookingReportStatusDTO:
//   { patientDTO, bookingDTO, paymentDue, allReportsCompleted, reports: [MakeReportHierarchyDTO...] }
//
// NOTE ON AUTH: MakeReportService.js (the logged-in service) sends
// `authType: 'PostLogin'` on every call because those screens sit behind a
// session. This page is PUBLIC — there is no logged-in user, only a mobile
// number the visitor types in — so we deliberately do NOT send that header.
// If your axiosInstance interceptor needs *some* authType to pick the right
// baseURL (rather than defaulting), swap 'PreLogin' below for whatever your
// app's convention is for anonymous/public calls.

import axiosInstance from '../../api/auth/axiosInstance';

export const LabReportService = {
  // Single entry point this page needs: booking id -> full status + patient +
  // (conditionally) the hierarchical report list.
  fetchBookingReportStatus: async (patientTestBookingId) => {
    try {
      const response = await axiosInstance.get(
        `/makereportfirsttype/public/booking/${patientTestBookingId}/report-status`,
        {
          headers: {
            authType: 'PreLogin', // public call — see note above
            baseURL: 'baseURL3',
          },
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch booking report status:', error);
      throw error;
    }
  },
};

export default LabReportService;